<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/FlowProduct/Flow' }">产品审批</el-breadcrumb-item>
            <el-breadcrumb-item>发起审批</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="24">
          <span style="text-align:left">产品类</span><el-badge :value="productFlows.length" type="primary"/>
           <el-divider></el-divider>
          <el-row :gutter="5">
            <el-col v-for="(item,index) in productFlows" :key="index" :span="3" >
              <el-button type="primary" :icon="productIcon" @click="CreateTask(item.ID,item.Name)" plain circle></el-button><div class="flowname"> {{item.Name}}</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { GetProductWorkFlow } from "../../until/ZeusApiSDK/Logic/WorkFlowProductLogic";
export default {
  data() {
    return {
      productFlows: [],
      productIcon: "el-icon-user-solid"
    };
  },
  created() {
    this.InitFlows();
  },
  methods: {
    InitFlows: function() {
      GetProductWorkFlow().then(res => {
          console.log('res',res);
        if (res.length > 0) {
        
          res.forEach(element => {
            if (element.Type === "产品类") {
              this.productFlows.push(element);
            } 
          });
        }
      });
    },
    CreateTask:function(flowid,flowname)
    {
        //name为索引index页面的值
      var to={name:"FlowProductCreateTask",params:{flowid:flowid,flowname:flowname}};
      //console.log('to',to);
      this.$router.push(to);
    }
  }
};
</script>
<style lang="less" scoped>
.flowname{
  color:#2c3e50;
  font-size: 12px;
  margin-top:5px;
  margin-bottom: 10px;
}

</style>